import { Flex } from '@mantine/core';
import { useThroughputTabStore } from '../../../../../../store/strategy-store/strategy-store';
import { toggleThroughputTypeVisibility } from '../../../../../../store/strategy-store/strategy-store.actions';
import { LineChartLegendItemWithCheckbox } from '../../../components/line-chart/line-chart-legend-item-with-checkbox';
import { getChartLineName, getLegendItems } from './initiative-progress-chart.helpers';

export const InitiativeProgressChartLegend = () => {
  const visibleThroughputTypes = useThroughputTabStore((state) => state.visibleThroughputTypes);
  const metric = useThroughputTabStore((state) => state.metric);

  const legendItems = getLegendItems();

  return (
    <Flex justify="center" align="center" gap="md" h="100%">
      {legendItems.map((item) => {
        const itemId = item.dataKey;
        const isChecked = visibleThroughputTypes[item.throughputType];
        const label = getChartLineName(item.dataKey, metric);

        return (
          <LineChartLegendItemWithCheckbox
            key={`legend-item-${itemId}`}
            value={itemId}
            label={label}
            color={item.color}
            isChecked={isChecked}
            onToggle={() => toggleThroughputTypeVisibility(item.throughputType)}
          />
        );
      })}
    </Flex>
  );
};
